import React from 'react';
import type { JobLifecycleEntry } from '../utils/jobLifecycleStorage';

/**
 * issue #76 Phase 4-β: 画面非表示中に完了したジョブを画面復帰時に通知するバナー (plan §13.4)。
 * ToastProvider 経由ではなく FingeringPage の通常レイアウト要素として配置 (toast と異なり
 * 画面遷移後も残るため明示的 dismiss が必要)。
 */
export interface CompletionBannerProps {
  entry: JobLifecycleEntry;
  onDismiss: () => void;
  onOpenHistory: () => void;
}

const CompletionBanner: React.FC<CompletionBannerProps> = ({ entry, onDismiss, onOpenHistory }) => {
  const fileName = entry.params?.fileName ?? '楽譜';
  return (
    <div
      role="status"
      aria-live="polite"
      className="bg-blue-50 border border-blue-200 text-blue-900 rounded-lg p-3 mb-3 flex items-start gap-3"
    >
      <span className="text-xl" aria-hidden="true">
        💡
      </span>
      <div className="flex-1">
        <p className="font-medium">前回投入した楽譜の処理が完了しました</p>
        <p className="text-sm text-blue-700 mt-1">
          フッタ「📚 履歴」から「{fileName}」 を復元できます。
        </p>
        <button
          type="button"
          onClick={onOpenHistory}
          className="mt-2 text-sm font-medium text-blue-700 hover:text-blue-900 underline"
        >
          📚 履歴を開く
        </button>
      </div>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="バナーを閉じる"
        className="text-blue-400 hover:text-blue-600 text-xl leading-none"
      >
        ×
      </button>
    </div>
  );
};

export default CompletionBanner;
